import React from "react";
import { CheckCircleOutlineRounded, ErrorOutlineRounded, InfoOutlined, WarningAmberRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

  const  BmAlert = (props) => {

    const {title, message, severity } = props;

    // --- Utility Functions ---

    const IconSelection = (severity) => {
      switch (severity) {
        case 'info':
            return <InfoOutlined  fontSize="medium" sx={{ verticalAlign: "middle", color: "#1893F8", mr: 1 }} />;
        case 'warning':
            return <WarningAmberRounded fontSize="medium" sx={{ verticalAlign: "middle", color: "#FFA000", mr: 1 }} />;
        case 'error':
            return <ErrorOutlineRounded fontSize="medium" sx={{ verticalAlign: "middle", color: "#D32F2F", mr: 1 }} />;
        case 'success':
            return <CheckCircleOutlineRounded fontSize="medium" sx={{ verticalAlign: "middle", color: "#388E3C", mr: 1 }} />;
        default:
            return <InfoOutlined fontSize="medium" sx={{ verticalAlign: "middle", color: "#1893F8", mr: 1 }} />;
    }}


    const AlertBoxBackgroundSelection = (severity) => {
      switch (severity) {
        case 'info':
            return "#A2D3FF4D"; // Lighter background for better contrast
        case 'warning':
            return "#FFF4E5";
        case 'error':
            return "#FFEBEE";
        case 'success':
            return "#E8F5E9";
        default:
            return "#A2D3FF4D";
    }}

    const AlertBoxBorderSelection = (severity) => {
      switch (severity) {
        case 'info':
            return "4px solid #1893F8"; // Reduced border width for aesthetics
        case 'warning':
            return "4px solid #FFA000";
        case 'error':
            return "4px solid #D32F2F";
        case 'success':
            return "4px solid #388E3C";
        default:
            return "4px solid #1893F8";
    }}

    const AlertBoxTitleColorSelection = (severity) => {
      switch (severity) {
        case 'info':
            return "#1893F8";
        case 'warning':
            return "#FFA000";
        case 'error':
            return "#D32F2F";
        case 'success':
            return "#388E3C";
        default:
            return "#1893F8";
    }
  };

    // --- Render ---

    return (
      <Box
        sx={{
          backgroundColor: AlertBoxBackgroundSelection(severity),
          p: 2,
          borderRadius: 1,
          mt: 2,
          borderLeft: AlertBoxBorderSelection(severity),
        }}
      >
        {IconSelection(severity)}

        <Typography
          variant="subtitle1"
          component="span"
          color={AlertBoxTitleColorSelection(severity)}
          fontWeight={600}
        >
          {title || null}
        </Typography>
        {/* <Typography
          variant="body2" // Changed subtitle2 to body2 for better hierarchy
          color="#4d4d4dff"
          fontWeight={300}
          sx={{ mt: 1 }}
        >
          {message || ""}
        </Typography> */}
        <Typography
          variant="body2"
          color="#4d4d4dff"
          fontWeight={300}
          sx={{ mt: 1 }}
        >
          {/* ✅ CRITICAL FIX: Remove the unnecessary string coercion. Render the 'message' prop directly. 
             If 'message' is an element (like a fragment), it renders. 
             If it's a string, it renders as text.
          */}
          {message || null}
        </Typography>
      </Box>
    );

  }
export default  BmAlert;
